<mat-card *ngIf="status === 'PENDING'" class="enter-key">
    <h2>Neues Passwort anfordern</h2>
    <form (ngSubmit)="onSubmit()">
        <p>
            <mat-form-field color="accent">
                <input matInput type="text" name="email" id="email" [formControl]="emailFormControl"
                    autocomplete="false" placeholder="E-Mail" required email />
                <mat-error *ngIf="emailFormControl.hasError('email')">
                    Geben Sie bitte eine gültige E-Mail-Adresse an.
                </mat-error>
                <mat-error *ngIf="emailFormControl.hasError('required')">
                    Bitte geben Sie E-Mail-adresse ein.
                </mat-error>
                <mat-error *ngIf="emailFormControl.hasError('found')">
                    Ihre E-Mail-Adresse konnte nicht gefunden werden.
                </mat-error>
            </mat-form-field>
        </p>
        <p>
            <button mat-flat-button color="accent" type="submit" #submitKey id="submitKey">
                Neues Passwort anfordern
            </button>
            <a class="lost-pw" routerLink="/">Zurück zur Anmeldung</a>
        </p>
    </form>
</mat-card>